/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PickUpStory,
    PickUpStoryFromJSON,
    PickUpStoryFromJSONTyped,
    PickUpStoryToJSON,
} from './PickUpStory';
import {
    PickUpVariables,
    PickUpVariablesFromJSON,
    PickUpVariablesFromJSONTyped,
    PickUpVariablesToJSON,
} from './PickUpVariables';

/**
 * 
 * @export
 * @interface GetPickUpStoryListResponse
 */
export interface GetPickUpStoryListResponse {
    /**
     * 
     * @type {PickUpVariables}
     * @memberof GetPickUpStoryListResponse
     */
    view: PickUpVariables;
    /**
     * 
     * @type {Array<PickUpStory>}
     * @memberof GetPickUpStoryListResponse
     */
    data: Array<PickUpStory>;
}

export function GetPickUpStoryListResponseFromJSON(json: any): GetPickUpStoryListResponse {
    return GetPickUpStoryListResponseFromJSONTyped(json, false);
}

export function GetPickUpStoryListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPickUpStoryListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'view': PickUpVariablesFromJSON(json['view']),
        'data': ((json['data'] as Array<any>).map(PickUpStoryFromJSON)),
    };
}

export function GetPickUpStoryListResponseToJSON(value?: GetPickUpStoryListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'view': PickUpVariablesToJSON(value.view),
        'data': ((value.data as Array<any>).map(PickUpStoryToJSON)),
    };
}

